<template>
    <div class="area mh-100 mv-100 w-100">
        <div v-if="cameraRendering" class="imgarea mv-100 w-100">
            <img v-if="!hasAuggie()" :src="imageUrl" class="img-fluid mh-100" alt="Camera">
        </div>
        <div v-if="!cameraRendering" class="container mt-1">
            <div v-if="gatherGyroInfo">
                <div class="row mt-2">
                    <div class="col-6">
                        <img v-if="!hasAuggie()" :src="imageUrl" class="img-fluid mh-100" alt="Camera">                        
                        <img v-if="hasAuggie()" :src="imageUrl" class="img-fluid mh-100" alt="Camera">                        
                    </div>
                    <div class="col-6">
                        <div class="row gyro-row">
                            <div class="col-4">Yaw</div>
                            <div class="col-4">Pitch</div>
                            <div class="col-4">Roll</div>
                            <div class="col-4">
                                <decimal-keyboard v-model="yaw"
                                                  css-class="form-control"
                                                  :maxlength="6"
                                                  input-name="yaw"
                                                  :allow-period="true"
                                                  :allow-negative="true"
                                                  placeholder="Yaw"
                                                  @showing="keyboardShown()"
                                                  @hiding="keyboardHidden()"
                                                  :readonly="loading" />
                            </div>
                            <div class="col-4">
                                <decimal-keyboard v-model="pitch"
                                                  css-class="form-control"
                                                  :maxlength="6"
                                                  input-name="yaw"
                                                  :allow-period="true"
                                                  :allow-negative="true"
                                                  placeholder="Pitch"
                                                  @showing="keyboardShown()"
                                                  @hiding="keyboardHidden()"
                                                  :readonly="loading" />
                            </div>
                            <div class="col-4">
                                <decimal-keyboard v-model="roll"
                                                  css-class="form-control"
                                                  :maxlength="6"
                                                  input-name="yaw"
                                                  :allow-period="true"
                                                  :allow-negative="true"
                                                  placeholder="Roll"
                                                  @showing="keyboardShown()"
                                                  @hiding="keyboardHidden()"
                                                  :readonly="loading" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="gatherImageData" class="row">
                <div>
                    <header-message v-if="gatherProgressValue < gatherProgressMaximum" class="mt-2 mb-2">
                        Image Data Collection In Progress...
                    </header-message>
                    <header-message v-if="gatherProgressValue >= gatherProgressMaximum" class="mt-2 mb-2">
                        Image Data Collection Completed
                    </header-message>
                    <progress-bar class="gather" :minimum="gatherProgressMinimum" :maximum="gatherProgressMaximum" :current="gatherProgressValue" ref="refgatherprogress" />
                </div>
            </div>
            <div v-if="sendingImage" class="row">
                <div>
                    <header-message v-if="uploadProgressValue < uploadProgressMaximum" class="mt-2 mb-2">
                        Camera Image Upload in Progress...
                    </header-message>
                    <header-message v-if="uploadProgressValue >= uploadProgressMaximum" class="mt-2 mb-2">
                        Camera Image Upload Completed
                    </header-message>
                    <progress-bar class="upload" :minimum="uploadProgressMinimum" :maximum="uploadProgressMaximum" :current="uploadProgressValue" ref="refuploadprogress" />
                </div>
            </div>
            <div v-if="awaitingConfirmation" class="row">
                <div>
                    <header-message v-if="confirmProgressValue < confirmProgressMaximum" class="mt-2 mb-2">
                        Camera Image Verification in Progress...
                    </header-message>
                    <header-message v-if="confirmProgressValue >= confirmProgressMaximum" class="mt-2 mb-2">
                        Camera Image Verification Completed
                    </header-message>
                    <progress-bar class="confirm" :minimum="confirmProgressMinimum" :maximum="confirmProgressMaximum" :current="confirmProgressValue" ref="refconfirmprogress" />
                </div>
            </div>
            <header-message class="text-danger mt-4">Do not move Auggie or Vehicle</header-message>
        </div>
        <div class="buttonrow">
            <div class="br-left">
                <button-button v-if="centerlinePhase" type="button" class="btn skip" @click.prevent="centerlineSkip" :disabled="loading">Skip</button-button>
            </div>
            <div class="phase-label">{{ centerlinePhase ? "Centerline" : "Camera Alignment" }}</div>
            <div class="br-right">
                <button-button type="button" class="btn btn-secondary me-4" @click.prevent="cancelClicked" :disabled="loading">Cancel</button-button>
                <spin-button v-if="centerlinePhase" class="btn-primary" type="submit" @click.prevent="centerlineProceed" :spinning="loading" :disabled="loading || (!centered && !DEBUG)">Proceed</spin-button>
                <spin-button v-else class="btn-primary" type="submit" @click.prevent="nextClicked" :spinning="loading" :disabled="loading || !yawRollValid || !bottomMarkersAvailable || !gyroValid() || sendingImage || awaitingConfirmation">Ready</spin-button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .buttonrow {
        left: 1rem; // global .buttonrow pins right: 1rem; stretch across so the label centers between Skip and the action buttons
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .br-right {
        display: flex;
        align-items: center;
    }
    .phase-label {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        color: #f8f9fa;
        font-size: 1.25rem;
        font-weight: 600;
    }
    .skip {
        background: transparent;
        border: none;
        color: #495057;
        text-decoration: none;
        font-size: 1.25rem;
        line-height: 3; // 1.25rem x 3 reproduces the .btn line box (2.5rem x 1.5) so the touch target keeps its height
        min-width: 6.25rem; // holds the width the label filled before it shrank

        &:hover,
        &:focus,
        &:active {
            color: #495057;
            text-decoration: none;
            box-shadow: none;
        }
    }
    .area {
        flex-grow: 1;
        overflow: hidden;
        position: relative;
        background: black;
        .imgarea {
            position: fixed;
            left: 0;
            top: 0;
            right: 0;
            height: 510px;
            text-align: center;
            background: black;
            img {
                height: 100%;
            }
        }
    }
    div.gyro-row,
    div.gyro-row input.form-control {
        font-size: 2rem !important;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import { confirmOk, confirmYesNo, isAlertDialogOpen } from "@/shared/components/common/AlertDialog.vue";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import { DataRequest } from "@/shared/support/Data";
import { CameraParserDto } from "@/shared/models/CameraParserDto";
import { CameraStatus } from "@/shared/enums/CameraStatus";
import { AUGGIEAVAILABLE } from "@/main";
import { CAMERASTARTFAILURELIMIT, Global } from "@/support/GlobalData";
import { SignalR } from "@/support/SignalR";
import CameraViewerConfiguration from "@/shared/models/CameraViewerConfiguration";
import { CenterlineThresholdDefault } from "@/shared/models/DeviceDto";
import { SessionType } from "@/shared/enums/SessionType";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";
import ChunkedUploadDto from "@/shared/models/ChunkedUploadDto";
import ProgressBar from "@/shared/components/common/ProgressBar.vue";
import Toast from "@/shared/support/Toast";
import OverlaySuppression from "@/shared/support/OverlaySuppression";

export default defineComponent({
    name: "CalibrationCameraReady",
    mixins: [PageBase],
    components: {
        HeaderMessage,
        ProgressBar,
    },
    data() {
        return {
            DEBUG: import.meta.env.VITE_DEBUG === "1",
            imageUrl: "",
            cameraRendering: false,
            sendingImage: false,
            awaitingConfirmation: false,
            cancelPromptOpen: false,
            gatherImageData: false,
            gatherGyroInfo: false,
            cameraTimeout: 0,
            doYawRollValid: false,
            doBottomMarkers: false,
            doLightIntensity: false,
            yawRollValid: false as boolean,
            bottomMarkersAvailable: true as boolean,
            centerlinePhase: false as boolean,
            centered: false as boolean,
            uploadProgressMinimum: 0,
            uploadProgressMaximum: 100,
            uploadProgressValue: 0,
            confirmProgressMinimum: 0,
            confirmProgressMaximum: 15, // assume 15 seconds for validation
            confirmProgressValue: 0,
            gatherProgressMinimum: 0,
            gatherProgressMaximum: 100,
            gatherProgressValue: 0,
            yaw: "",
            pitch: "",
            roll: "",
            hasKeyboard: false,
        };
    },
    methods: {
        keyboardShown(): void {
            this.hasKeyboard = true;
        },
        keyboardHidden(): void {
            this.hasKeyboard = false;
        },

        hasAuggie(): boolean {
            return AUGGIEAVAILABLE;
        },

        async getCameraInfo(): Promise<void> {

            this.loading = true;

            this.cameraRendering = true;

            let cameraConfig: CameraViewerConfiguration|null = null;
            if (Global.IsDemo()) {

                cameraConfig = await this.loadDemoConfiguration();
                console.debug(`CameraViewerConfiguration: ${JSON.stringify(cameraConfig)}`);

            } else {
                try {
                    const dr = new DataRequest();
                    dr.autoToastOnFailure = false;
                    const session = Global.CalibrationSession!;
                    cameraConfig = await dr.$get<CameraViewerConfiguration>("/Service/CalibrationSession/GetCameraViewerConfiguration", { CalibrationSessionGuid: session.CalibrationSessionGuid });
                } catch (error) {
                    cameraConfig = null;
                }
            }

            this.loading = false;

            if (!cameraConfig) {
                this.cameraRendering = false;
                confirmOk("Unable to obtain camera information");
                this.$router.push("/Calibration/CameraSetup");
                return;
            }

            Global.MainApp.setCameraConfig(cameraConfig);
            this.loadCameraImage();
        },

        loadCameraImage(): void {
            this.loading = true;

            // Centerline runs first (same camera, no re-init) when enabled, supported by the client, and not yet completed.
            const centerlineSupported = Global.IsCenterlineSupported();
            const startInCenterline = centerlineSupported && Global.CenterlineEnabledInd && !Global.CenterlineCompleted;

            if (!AUGGIEAVAILABLE) {
                setTimeout((): void => {
                    this.imageUrl = "/img/Toyota_Corolla_2019_originalframe_1628026473.png";
                    this.loading = false;
                    if (startInCenterline) {
                        this.centerlinePhase = true;
                        this.centered = true; // no native detection in demo
                        this.getCurrentStatusForListeners();
                    } else {
                        this.enterAlignmentPhase();
                    }
                }, 500);
            } else {
                setTimeout((): void => {
                    if (!this.startCameraRender(startInCenterline)) return;
                    this.loading = false;
                    if (startInCenterline)
                        this.getCurrentStatusForListeners();
                    else
                        this.enterAlignmentPhase();
                }, 10);// allow update of form before rendering camera
            }
        },

        // Starts the native render in the given phase and reads its first status. Returns false when the
        // camera could not be started; cameraStartFailed has already routed away.
        startCameraRender(centerline: boolean): boolean {
            this.setLightIntensity(Global.LightIntensity);
            // Only an explicit false is a failure; an older client returns nothing at all.
            if (Auggie.Camera.InitializeRender(JSON.stringify(Global.CameraViewerConfiguration)) === false) {
                this.cameraStartFailed();
                return false;
            }
            Global.CameraStartFailures = 0;
            if (OverlaySuppression.isSuppressed())
                Global.MainApp.setCameraWindowSuppressed(true);
            this.centerlinePhase = centerline;
            if (Global.IsCenterlineSupported())
                Auggie.Camera.SetCenterLineActive(centerline);
            Auggie.Camera.RenderProcessedCameraImage();
            this.readCameraStatus();
            this.renderCameraImage();
            return true;
        },

        readCameraStatus(): void {
            if (this.centerlinePhase) {
                this.centered = Auggie.Camera.CenterLineReached();
                return;
            }
            this.yawRollValid = this.doYawRollValid ? Auggie.Camera.YawRollValid() : true;
            this.bottomMarkersAvailable = this.doBottomMarkers ? Auggie.Camera.BottomMarkersAvailable() : true;
        },

        // The client could not take the camera over from the previous session, so no frames are coming.
        // The client hides its own overlay window on this path, because the thread that would apply a
        // hide requested from here is the one still holding the camera.
        cameraStartFailed(): void {
            this.cameraRendering = false;
            this.loading = false;
            Global.CameraStartFailures++;
            // Management waits on the camera and has no other way to learn it is not coming. It cancels
            // its retry timer on this event and tells the technician.
            CalibrationEventSupport.sendEventDeviceFailure("Unable to start the camera");
            // Silent only while a technician-controlled session will advance back into the camera on its
            // own, since the pipeline usually frees within a pass or two. An operator who pressed the
            // button is told straight away, and so is a technician once retrying has stopped helping.
            if (!Global.IsTechControlled || Global.CameraStartFailures >= CAMERASTARTFAILURELIMIT)
                confirmOk("Unable to start the camera. Please try again.");
            this.$router.push("/Calibration/CameraSetup");
        },

        renderCameraImage(): void {
            this.cameraTimeout = setTimeout((): void => {
                this.cameraTimeout = 0;
                // No-op on a client whose render thread produces frames; older clients render here.
                Auggie.Camera.RenderProcessedCameraImage();
                this.readCameraStatus();
                this.renderCameraImage();
            }, 10) as unknown as number;
        },
        clearCameraTimeout(): void {
            if (this.cameraTimeout) {
                clearTimeout(this.cameraTimeout);
                this.cameraTimeout = 0;
            }
        },
        clearLights(): void {
            this.setLightIntensity(0);
        },
        terminateCameraRender(): void {
            if (AUGGIEAVAILABLE) {
                Auggie.Camera.TerminateRender();
            }
        },

        getGyroInfo(): void {
            Auggie.Camera.EndCameraDisplay();// shut down the overlay
            const lastProcessedFrame = Auggie.Camera.GetLastProcessedFrame();
            if (lastProcessedFrame)
                this.imageUrl = lastProcessedFrame;

            this.gatherGyroInfo = true;
            this.gatherImageData = false;
            this.cameraRendering = false;
        },

        gyroValid(): boolean {
            if (!this.gatherGyroInfo) return true;
            if (this.yaw === "" && this.pitch === "" && this.roll === "") return true;
            const yaw = Number(this.yaw);
            if (this.yaw === "" || isNaN(yaw)) return false;
            const pitch = Number(this.pitch);
            if (this.pitch === "" || isNaN(pitch)) return false;
            const roll = Number(this.roll);
            if (this.roll === "" || isNaN(roll)) return false;
            return true;
        },

        enterAlignmentPhase(): void {
            SignalR.onGetCameraAlignmentImage = this.getCameraAlignmentImage;
            this.captureAmbientLightAlignment();
            CalibrationEventSupport.sendEvent(CalibrationEvent.CameraAlignmentReached);
            this.getCurrentStatusForListeners();
        },
        centerlineProceed(): void {
            if (!this.centered && !this.DEBUG) {
                // Rejected (target not centered) — echo status so a remote listener updates.
                this.getCurrentStatusForListeners(false);
                return;
            }
            CalibrationEventSupport.sendEvent(CalibrationEvent.CenterlineAccepted);
            if (AUGGIEAVAILABLE && !Global.IsDemo())
                this.captureAndUploadCenterlineImage();
            this.finishCenterline();
        },
        centerlineSkip(): void {
            CalibrationEventSupport.sendEvent(CalibrationEvent.CenterlineSkipped);
            this.finishCenterline();
        },
        finishCenterline(): void {
            Global.CenterlineCompleted = true;
            this.centerlinePhase = false;
            this.centered = false;
            if (AUGGIEAVAILABLE && Global.IsCenterlineSupported())
                Auggie.Camera.SetCenterLineActive(false);
            if (!this.doYawRollValid)
                this.yawRollValid = true;
            // Camera keeps rendering; switch to the alignment overlay in place (no re-init).
            this.enterAlignmentPhase();
        },
        captureAndUploadCenterlineImage(): void {
            if (!Global.CalibrationSession) return;
            // Best-effort: the synchronous native capture must not throw out of here, or finishCenterline never runs.
            try {
                const cameraImage = Auggie.Camera.GetProcessedCameraImage();
                if (!cameraImage) return;
                fetch(cameraImage)
                    .then((response): Promise<Blob> => response.blob())
                    .then((blob: Blob): Promise<ChunkedUploadDto> => {
                        const dr = new DataRequest();
                        dr.autoToastOnFailure = false;
                        return dr.$postChunkedFile(Global.CalibrationSession!.CalibrationSessionGuid, blob, (count:number, total:number):void => { /* deliberately empty */ });
                    })
                    .then((uploadDto: ChunkedUploadDto): Promise<CameraParserDto> => {
                        const dr2 = new DataRequest();
                        dr2.autoToastOnFailure = false;
                        return dr2.$post<any, CameraParserDto>("/Service/CameraParser/CenterlineImage", {
                            DeviceGuid: Global.DeviceGuid,
                            CalibrationSessionGuid: Global.CalibrationSession!.CalibrationSessionGuid,
                            FileName: uploadDto.FileName,
                            FileSize: uploadDto.FileSize,
                            ContentType: uploadDto.ContentType,
                        });
                    })
                    .catch((): void => { /* best-effort; do not block the flow */ });
            } catch (e) {
                console.warn("Centerline image capture error:", e);
            }
        },

        nextClicked(): void {
            if (this.refusedDuringCancelPrompt()) return;
            if (this.centerlinePhase) {
                this.centerlineProceed();
                return;
            }
            SignalR.onGetCameraAlignmentImage = null;
            SignalR.onCameraVerificationByTechnician = null;
            SignalR.onCameraVerificationByCompanion = null;
            this.clearCameraTimeout();

            if (!Global.IsTechControlled && Global.DebugGyroYPR) {
                if (this.gatherGyroInfo) {
                    // already gathering gyro y/p/r
                    if (!this.gyroValid()) {
                        Toast.error("Please enter valid Yaw, Pitch and Roll values");
                        return;
                    }
                    if (AUGGIEAVAILABLE && Global.IsVersionAtLeast(Global.GyroPackageVersion)) {
                        if (this.yaw === "" && this.pitch === "" && this.roll === "") {
                            // no values entered, use aruco values
                        } else {
                            Auggie.Camera.SetGyroYPROverride(Number(this.yaw), Number(this.pitch), Number(this.roll));
                        }
                    }
                    // continue below
                } else {
                    // not yet gathering Gyro information, switch to gyro information display
                    this.getGyroInfo();
                    return;
                }
            }

            // get a processed camera image in demo mode so we can display it later
            if (Global.IsDemo()) {
                if (!AUGGIEAVAILABLE)
                    Global.DemoCameraImage = "/img/Toyota_Corolla_2019_originalframe_1628026473.png"; // debugging stand-alone only
                else {
                    const demoImage = Auggie.Camera.GetProcessedCameraImage();
                    if (demoImage)
                        Global.DemoCameraImage = demoImage;
                }
            }

            this.loading = true;
            if (AUGGIEAVAILABLE) {
                this.gatherCameraData();
            } else {
                this.fetchCameraImage();
            }
        },
        nextClickedCompanion(): void {
            if (this.refusedDuringCancelPrompt()) return;
            if (this.centerlinePhase) {
                if (this.centered)
                    this.centerlineProceed();
                else
                    this.getCurrentStatusForListeners(false);
                return;
            }
            if (this.yawRollValid && this.bottomMarkersAvailable) {
                this.nextClicked();
            } else {
                this.getCurrentStatusForListeners(this.yawRollValid, this.bottomMarkersAvailable);
            }
        },

        gatherCameraData(): void {
            if (!AUGGIEAVAILABLE || !Global.IsVersionAtLeast("2023.205.1")) {
                this.fetchCameraImage();
                return;
            }

            Auggie.Camera.EndCameraDisplay();// shut down the overlay

            this.gatherImageData = true;
            this.cameraRendering = false;
            this.gatherGyroInfo = false;

            this.$forceUpdate();

            // show the progress bar
            this.gatherProgressMinimum = 0;
            this.gatherProgressMaximum = Auggie.Camera.GetMissingFrames();
            console.log(`Remaining frames needed: ${this.gatherProgressMaximum}`);
            this.gatherProgressValue = 0;

            this.gatherOneCameraImage();
        },

        gatherOneCameraImage(): void {
            if (!Auggie.Camera.MaxFramesReached()) {
                setTimeout((): void => { // make sure other things are also dispatched while we're getting camera images
                    Auggie.Camera.RenderProcessedCameraImage();
                    const remaining = Auggie.Camera.GetMissingFrames();
                    console.log(`Remaining frames needed: ${remaining}`);
                    this.gatherProgressValue = this.gatherProgressMaximum - remaining;
                    this.gatherOneCameraImage();// again
                }, 10);
                return;
            } else {
                this.gatherProgressValue = this.gatherProgressMaximum;
            }
            this.fetchCameraImage();
        },

        fetchCameraImage(): void {
            // get an unprocessed camera image and send it to the camera parser.
            let cameraImage: string;
            let cameraData: string|null;
            if (!AUGGIEAVAILABLE) {
                cameraImage = "/img/Toyota_Corolla_2019_originalframe_1628026473.png"; // debugging stand-alone only
                const fakeData = {
                    "Roll": 0.51154808003420316,
                    "Yaw": 0.67462799417747665,
                    "YawRollDecimals": 2,
                    "MarkerCorners": [
                        [
                            [
                                {
                                    "X": 1206,
                                    "Y": 684
                                },
                                {
                                    "X": 1311,
                                    "Y": 682
                                },
                                {
                                    "X": 1330,
                                    "Y": 770
                                },
                                {
                                    "X": 1219,
                                    "Y": 771
                                }
                            ],
                            [
                                {
                                    "X": 778,
                                    "Y": 562
                                },
                                {
                                    "X": 875,
                                    "Y": 559
                                },
                                {
                                    "X": 868,
                                    "Y": 630
                                },
                                {
                                    "X": 766,
                                    "Y": 635
                                }
                            ],
                            [
                                {
                                    "X": 1186,
                                    "Y": 548
                                },
                                {
                                    "X": 1280,
                                    "Y": 547
                                },
                                {
                                    "X": 1296,
                                    "Y": 617
                                },
                                {
                                    "X": 1196,
                                    "Y": 619
                                }
                            ],
                            [
                                {
                                    "X": 1356,
                                    "Y": 456
                                },
                                {
                                    "X": 1443,
                                    "Y": 457
                                },
                                {
                                    "X": 1465,
                                    "Y": 514
                                },
                                {
                                    "X": 1373,
                                    "Y": 513
                                }
                            ],
                            [
                                {
                                    "X": 1090,
                                    "Y": 456
                                },
                                {
                                    "X": 1178,
                                    "Y": 455
                                },
                                {
                                    "X": 1185,
                                    "Y": 513
                                },
                                {
                                    "X": 1093,
                                    "Y": 513
                                }
                            ],
                            [
                                {
                                    "X": 756,
                                    "Y": 700
                                },
                                {
                                    "X": 862,
                                    "Y": 696
                                },
                                {
                                    "X": 854,
                                    "Y": 786
                                },
                                {
                                    "X": 740,
                                    "Y": 791
                                }
                            ],
                            [
                                {
                                    "X": 823,
                                    "Y": 462
                                },
                                {
                                    "X": 911,
                                    "Y": 459
                                },
                                {
                                    "X": 904,
                                    "Y": 516
                                },
                                {
                                    "X": 810,
                                    "Y": 518
                                }
                            ]
                        ]
                    ],
                    "MarkerIds": [
                        [
                            13,
                            11,
                            12,
                            2,
                            1,
                            10,
                            0
                        ]
                    ]
                };
                cameraData = JSON.stringify(fakeData);
            } else if (Global.IsVersionAtLeast("2022.255.0")) {
                cameraImage = Auggie.Camera.GetLastFrame();
                cameraData = Auggie.Camera.GetLastData();
            } else {
                cameraImage = Auggie.Camera.GetCameraImage();
                cameraData = null;
            }

            this.clearLights();
            this.terminateCameraRender();
            this.cameraRendering = false;

            if (!cameraImage) {
                this.cameraImageRetrievalFailed();
                return;
            }

            fetch(cameraImage)
                .then((response): Promise<Blob> => {
                    return response.blob();
                })
                .then((blob: Blob): void => {
                    this.loading = false;
                    this.sendCameraImageToValidate(blob, cameraData);
                })
                .catch((): void => {
                    this.cameraImageRetrievalFailed();
                });
        },

        cameraImageRetrievalFailed(): void {
            this.loading = false;
            const msg = "An error occurred retrieving the camera image";
            CalibrationEventSupport.sendEventDeviceFailure(msg);
            confirmOk(msg);
            this.$router.push("/Calibration/CameraSetup");
        },

        sendCameraImageToValidate(blob: Blob|null, cameraData: string|null): void {

            if (!Global.CalibrationSession) {
                console.error("Sending camera image without active session");
                confirmOk("The current session is no longer available due to network errors");
                this.$router.push("/");
                return;
            }

            this.sendingImage = true;
            this.getCurrentStatusForListeners();

            if (Global.IsDemo()) {

                let seconds = 1;
                const maxSeconds = Number(import.meta.env.VITE_DEMODELAY!);
                const interval = setInterval((): void => {
                    const uploadProgress = this.$refs.refuploadprogress;
                    if (uploadProgress) {
                        this.uploadProgressMinimum = 0;
                        this.uploadProgressMaximum = maxSeconds;
                        this.uploadProgressValue = seconds;
                    }
                    ++seconds;
                    if (seconds > maxSeconds) {
                        clearInterval(interval);
                        if (this.pageGone) return;
                        this.saveUploadedValidationImage({} as ChunkedUploadDto, cameraData);
                    }
                }, 1000);

            } else {

                const dr = new DataRequest();
                dr.$postChunkedFile(Global.CalibrationSession!.CalibrationSessionGuid, blob!, (count:number, total:number):void => {
                    const uploadProgress = this.$refs.refuploadprogress;
                    if (uploadProgress) {
                        this.uploadProgressMinimum = 0;
                        this.uploadProgressMaximum = total;
                        this.uploadProgressValue = count;
                    }
                })
                    .then((uploadDto: ChunkedUploadDto): void => {
                        if (this.pageGone) return;
                        this.saveUploadedValidationImage(uploadDto, cameraData);
                    })
                    .catch((reason): void => {
                        if (this.pageGone) return;
                        this.sendingImage = false;
                        const msg = `An unexpected error occurred verifying the camera position - ${reason}`;
                        CalibrationEventSupport.sendEventDeviceFailure(msg);
                        confirmOk(msg);
                        this.$router.push("/Calibration/CameraSetup");
                    });
            }
        },

        saveUploadedValidationImage(uploadDto: ChunkedUploadDto, cameraData: string|null): void {

            this.awaitingConfirmation = true;

            if (Global.IsDemo()) {
                this.confirmProgressMaximum = Number(import.meta.env.VITE_DEMODELAY!);
                this.confirmProgressMinimum = 0;
                this.confirmProgressValue = 0;

                let seconds = 0;
                const interval = setInterval((): void => {
                    this.confirmProgressValue = seconds;
                    if (seconds < this.confirmProgressMaximum) {
                        ++seconds;
                    } else {
                        clearInterval(interval);
                        if (this.pageGone) return;
                        this.confirmationReceived(true);
                    }
                }, 1000);

            } else {
                let seconds = 0;
                const interval = setInterval((): void => {
                    this.confirmProgressValue = seconds;
                    if (seconds < this.confirmProgressMaximum - 1)
                        ++seconds;
                    else
                        clearInterval(interval);
                }, 1000);

                const dr = new DataRequest(undefined, undefined, 3);// 3 retries
                dr.$post<any, CameraParserDto>("/Service/CameraParser/Validate", {
                    DeviceGuid: Global.DeviceGuid,
                    CalibrationSessionGuid: Global.CalibrationSession!.CalibrationSessionGuid,
                    IgnoreCameraCalibration: Global.IgnoreCameraCalibration(),
                    FileName: uploadDto.FileName,
                    FileSize: uploadDto.FileSize,
                    ContentType: uploadDto.ContentType,
                }, cameraData)
                    .then((parserResult: CameraParserDto): void => {
                        clearInterval(interval);
                        if (this.pageGone) return;
                        this.confirmProgressValue = this.confirmProgressMaximum;
                        this.sendingImage = false;
                        if (parserResult.UpdateResult.Success) {
                            if (parserResult.CameraStatus === CameraStatus.Found) {
                                this.confirmationReceived(true);
                            } else {
                                this.confirmationReceived(false);
                            }
                        } else {
                            this.confirmationReceived(false);
                        }
                    })
                    .catch((reason): void => {
                        clearInterval(interval);
                        if (this.pageGone) return;
                        this.sendingImage = false;
                        this.awaitingConfirmation = false;
                        const msg = `An unexpected error occurred verifying the camera position - ${reason}`;
                        CalibrationEventSupport.sendEventDeviceFailure(msg);
                        // In tech-controlled mode the technician is remote and can't dismiss a device-side
                        // modal; the failure is surfaced to them via the DeviceFailure event.
                        if (!Global.IsTechControlled) {
                            confirmOk(msg);
                        }
                        this.$router.push("/Calibration/CameraSetup");
                    });
            }
        },

        sendCameraAlignmentImage(blob: Blob|null): void {

            if (!Global.CalibrationSession) {
                console.error("Sending camera image without active session");
                confirmOk("The current session is no longer available due to network errors");
                this.$router.push("/");
                return;
            }

            const dr = new DataRequest();
            dr.$postChunkedFile(Global.CalibrationSession!.CalibrationSessionGuid, blob!, (count:number, total:number):void => { /* deliberately empty */ })
                .then((uploadDto: ChunkedUploadDto): void => {
                    const dr = new DataRequest();
                    dr.$post<any, CameraParserDto>("/Service/CameraParser/CameraAlignmentImage", {
                        DeviceGuid: Global.DeviceGuid,
                        CalibrationSessionGuid: Global.CalibrationSession!.CalibrationSessionGuid,
                        FileName: uploadDto.FileName,
                        FileSize: uploadDto.FileSize,
                        ContentType: uploadDto.ContentType,
                    });
                });
        },

        getCameraAlignmentImage(): void {

            // get a processed camera image and upload it
            let cameraImage: string;
            if (!AUGGIEAVAILABLE)
                cameraImage = "/img/Toyota_Corolla_2019_originalframe_1628026473.png"; // debugging stand-alone only
            else {
                cameraImage = Auggie.Camera.GetProcessedCameraImage();
            }

            if (!cameraImage) {
                // Management waits on this image and has no other way to learn it is not coming, so the
                // failure is reported rather than returned quietly.
                this.cameraAlignmentImageUnavailable();
                return;
            }

            fetch(cameraImage)
                .then((response): Promise<Blob> => {
                    return response.blob();
                })
                .then((blob: Blob): void => {
                    this.loading = false;
                    this.sendCameraAlignmentImage(blob);
                })
                .catch((reason): void => {
                    this.loading = false;
                });
        },

        // The technician asked for this image and keeps control of the session, so the device reports the
        // failure and stays where it is rather than routing away. Management cancels its retry timer on
        // this event and tells the technician, who can ask again once frames are coming.
        cameraAlignmentImageUnavailable(): void {
            this.loading = false;
            CalibrationEventSupport.sendEventDeviceFailure("The camera image is not available");
        },

        confirmationReceived(accept: boolean): void {
            this.awaitingConfirmation = false;
            if (Global.TechnicianName) {
                // under technician control, always go to in progress page. technician will decide what to do
                // based on the camera image which has pass/fail information.
                this.$router.push("/Calibration/InProgress");
            } else if (accept) {
                if (Global.SessionType === SessionType.SelfCalibration)
                    this.$router.push("/Calibration/CameraImage");
                else
                    this.$router.push("/Calibration/Contacting");
            } else {
                confirmOk("The Auggie is not correctly positioned. Please verify Auggie position.");
                this.$router.push("/Calibration/CameraSetup");
            }
        },

        setLightIntensity(intensity: number): void {
            if (AUGGIEAVAILABLE) {
                if (this.doLightIntensity)
                    Auggie.Lights.SetIntensity(intensity);
                else if (intensity < 1)
                    Auggie.Camera.LightOff();
                else
                    Auggie.Camera.LightOn();
            }
        },

        cancelClicked(): void {
            // A client that cannot hide the camera window has the render torn down for the prompt instead.
            const tornDown = this.cameraRendering && !Global.IsVersionAtLeast(Global.CameraWindowVisibilityVersion);
            if (tornDown) {
                SignalR.onGetCameraAlignmentImage = null;
                this.clearCameraTimeout();
                this.clearLights();
                this.terminateCameraRender();
                this.cameraRendering = false;
            }
            this.cancelPromptOpen = true;
            confirmYesNo("Are you sure you want to cancel this calibration?")
                .then((clicked: ButtonClicked): void => {
                    this.cancelPromptOpen = false;
                    if (this.pageGone) return;
                    if (clicked === ButtonClicked.Ok) {
                        CalibrationEventSupport.sendEvent(CalibrationEvent.CalibrationCustomerCanceled);
                        Global.MainApp.clearSession();
                        this.$router.push("/");
                    } else if (tornDown) {
                        this.resumeCameraRender();
                    }
                });
        },

        // Restarts the render torn down for the cancel prompt, staying in the phase the page was in. Only
        // the SignalR handler is restored, not enterAlignmentPhase: the phase was already entered, and
        // re-entering would resend CameraAlignmentReached and recapture the ambient light.
        resumeCameraRender(): void {
            this.cameraRendering = true;
            if (!AUGGIEAVAILABLE) return;
            if (!this.startCameraRender(this.centerlinePhase)) return;
            if (!this.centerlinePhase)
                SignalR.onGetCameraAlignmentImage = this.getCameraAlignmentImage;
        },

        // A remote verification is refused while the operator is deciding whether to cancel, so the
        // calibration cannot move on underneath the prompt. The status echo tells the remote side.
        refusedDuringCancelPrompt(): boolean {
            if (!this.cancelPromptOpen || !isAlertDialogOpen()) return false;
            this.getCurrentStatusForListeners(false);
            return true;
        },

        getCurrentStatusForListeners(yawRollValid?: boolean, bottomMarkersAvailable?: boolean): void {
            if (this.centerlinePhase) {
                CalibrationEventSupport.sendEventStatus({
                    Page: "CalibrationCameraReady",
                    Centerlining: true,
                } as DeviceStatusDto);
            } else if (this.sendingImage) {
                CalibrationEventSupport.sendEventStatus({
                    Page: "CalibrationCameraReady",
                    CameraVerifying: true,
                } as DeviceStatusDto);
            } else {
                CalibrationEventSupport.sendEventStatus({
                    Page: "CalibrationCameraReady",
                    CameraVerifying: false,
                    YawRollValid: yawRollValid,
                    BottomMarkersAvailable: bottomMarkersAvailable,
                } as DeviceStatusDto);
            }
        },

        captureAmbientLightAlignment(): void {
            // Capture ambient light sensor value during camera alignment
            if (!AUGGIEAVAILABLE) return;
            if (!Global.IsVersionAtLeast("2026.15.1")) return;
            try {
                const infoString = Auggie.Device.AmbientLightInfo();
                if (infoString?.length > 0) {
                    const info = JSON.parse(infoString);
                    if (info && info.AmbientLight != null) {
                        Global.AmbientLightAlignment = info.AmbientLight;
                        CalibrationEventSupport.sendAmbientLightInformation();
                    }
                }
            } catch (error) {
                console.error("Error capturing ambient light alignment:", error);
            }
        },

        async loadDemoConfiguration(): Promise<CameraViewerConfiguration|null> {
            const distortion = await this.loadDemoCameraDistortion();
            if (!distortion) return null;
            const matrix = await this.loadDemoCameraMatrix();
            if (!matrix) return null;
            const offsets = await this.loadDemoCameraOffsets();
            if (!offsets) return null;
            const cameraParms = await this.loadDemoCameraParameters();
            if (!cameraParms) return null;

            const config : CameraViewerConfiguration = {
                CarYear: Global.Year.toString(),
                CarMake: Global.Make,
                CarModel: Global.Model,
                CarCameraHeight: Global.DemoVehicle!.CameraHeight,
                CarTargetHeight:1300.0,// Not Used for Viewer in Demo mode
                CarTargetToCamera:3700.0,// Not Used for Viewer in Demo mode
                CarCameraMountingOffset: Global.DemoVehicle!.CameraMountingOffset,
                CarWindshieldAngle: Global.DemoVehicle!.WindshieldAngle,
                YawRollDecimals: 1,
                UseGyroYPRInd: false,
                DebugGyroInd: false,
                GyroYaw: 0,
                GyroPitch: 0,
                GyroRoll: 0,
                ActualYaw: 0,
                ActualPitch: 0,
                ActualRoll: 0,
                CameraDistortion: distortion,
                CameraMatrix: matrix,
                AuggieCameraPitch: offsets[0],
                AuggieCameraRoll: offsets[1],
                AuggieCameraYaw: offsets[2],
                CameraToScreenXDif: cameraParms[0],
                CameraToScreenYDif: cameraParms[1],
                CameraToScreenZDif: cameraParms[2],
                MarkerLength: cameraParms[3],
                ZOffset: cameraParms[4],
                RefractionOffset: cameraParms[5],
                ConfidenceThreshold: 0.5, // not configurable
                CenterLineThreshold: CenterlineThresholdDefault // demo has no device configuration, so use the default tolerance
            };
            return config;
        },
        async loadDemoCameraDistortion(): Promise<number[]|null> {
            const fileName = "CameraDistortionParameters.csv";
            const lines: string[] = await this.readLines(fileName);
            if (lines.length < 2) {
                Toast.error(`${fileName} is invalid, expected 2 lines, got ${lines.length}`);
                return null;
            }
            const distortion  = lines[1].split(/,/);
            if (distortion.length !== 5) {
                Toast.error(`${fileName} line 2 is invalid - ${lines[1]}`);
                return null;
            }
            const distArray: number[] = [];
            for (const dist of distortion) {
                const d = Number(dist);
                if (isNaN(d)) {
                    Toast.error(`Invalid number in ${fileName} line 2 - ${lines[1]}`);
                    return null;
                }
                distArray.push(d);
            }
            return distArray;
        },
        async loadDemoCameraMatrix(): Promise<number[]|null> {
            const fileName = "CameraIntrinsicParameters.csv";
            const lines: string[] = await this.readLines(fileName);
            if (lines.length < 4) {
                Toast.error(`${fileName} is invalid, expected 4 lines, got ${lines.length}`);
                return null;
            }
            const matrixArray: number[] = [];
            for (let l = 1 ; l < 4 ; ++l) {
                const line = lines[l];
                const matrix  = line.split(/,/);
                if (matrix.length !== 3) {
                    Toast.error(`${fileName} line ${l} is invalid - ${lines[l]}`);
                    return null;
                }
                for (const mat of matrix) {
                    const m = Number(mat);
                    if (isNaN(m)) {
                        Toast.error(`Invalid number in ${fileName} line ${l} - ${lines[l]}`);
                        return null;
                    }
                    matrixArray.push(m);
                }
            }
            return matrixArray;
        },
        async loadDemoCameraOffsets(): Promise<number[]|null> {
            const fileName = "CameraOffsets.csv";
            const lines: string[] = await this.readLines(fileName);
            if (lines.length < 2) {
                Toast.error(`${fileName} is invalid, expected 2 lines, got ${lines.length}`);
                return null;
            }
            const offsets  = lines[1].split(/,/);
            if (offsets.length !== 3) {
                Toast.error(`${fileName} line 2 is invalid - ${lines[1]}`);
                return null;
            }
            const offsArray: number[] = [];
            for (const offs of offsets) {
                const o = Number(offs);
                if (isNaN(o)) {
                    Toast.error(`Invalid number in ${fileName} line 2 - ${lines[1]}`);
                    return null;
                }
                offsArray.push(o);
            }
            return offsArray;
        },
        async loadDemoCameraParameters(): Promise<number[]|null> {
            const fileName = "CameraParameters.csv";
            const lines: string[] = await this.readLines(fileName);
            if (lines.length < 2) {
                Toast.error(`${fileName} is invalid, expected 2 lines, got ${lines.length}`);
                return null;
            }
            const parmeters  = lines[1].split(/,/);
            if (parmeters.length !== 6) {
                Toast.error(`${fileName} line 2 is invalid - ${lines[1]}`);
                return null;
            }
            const parmArray: number[] = [];
            for (const parm of parmeters) {
                const p = Number(parm);
                if (isNaN(p)) {
                    Toast.error(`Invalid number in ${fileName} line 2 - ${lines[1]}`);
                    return null;
                }
                parmArray.push(p);
            }
            return parmArray;
        },

        async readLines(file: string): Promise<string[]> {
            const response = await fetch(`/demo/calibration/${file}`);
            const blob = await response.blob();
            const contents = await blob.text();
            const lines = contents.split(/\r?\n/);
            return lines;
        }
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onCameraVerificationByTechnician = this.nextClicked;
        SignalR.onCameraVerificationByCompanion = this.nextClickedCompanion;
        SignalR.onSetLightIntensity = this.setLightIntensity;

        this.doYawRollValid = false;
        this.doLightIntensity = false;
        if (AUGGIEAVAILABLE) {
            if (Global.IsVersionAtLeast("0.9.15")) {
                this.doYawRollValid = true;
                this.doLightIntensity = true;
            }
        }
        if (!this.doYawRollValid)
            this.yawRollValid = true;
        this.doBottomMarkers = AUGGIEAVAILABLE && Global.IsBottomMarkerGateSupported();
        this.getCameraInfo();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onGetCameraAlignmentImage = null;
        SignalR.onCameraVerificationByTechnician = null;
        SignalR.onCameraVerificationByCompanion = null;
        SignalR.onSetLightIntensity = null;

        this.clearCameraTimeout();
        this.clearLights();
        this.terminateCameraRender();
    }
});
</script>
